/**
 * # Page Wrapper Dark
 */

/**
 * ## Imports
 */
import './PageWrapperDark.scss';

import cx from 'classnames';

/**
 * ## Component
 * @param {object} children
 * @returns React
 */
const PageWrapperDark = ({ children, isDisableScroll = false }) => {
    return (
        <div
            className={cx('pagewrapper-dark teaser-headline-decoration', {
                'scroll-disable': isDisableScroll,
            })}
        >
            {children}
        </div>
    );
};

export default PageWrapperDark;
